// @ts-strict

import { mongoose } from "@typegoose/typegoose";

export {};

declare global {
    interface String {
        toMongoId(): mongoose.Types.ObjectId;
    }
}

// eslint-disable-next-line no-extend-native
Object.defineProperty(String.prototype, "toMongoId", {
    value: function toMongoId(this: string): mongoose.Types.ObjectId {
        return new mongoose.Types.ObjectId(this);
    },
    writable: true,
    configurable: true,
});
